'use client';

import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';

import { MAIN_CONTENT_ID } from './constants';

export default function SkipToMainContent() {
    const { t } = useTranslation('common');

    return (
        <a
            href={`#${MAIN_CONTENT_ID}`}
            className={cn(
                'fixed top-0.5 start-4 z-[100] bg-background px-4 py-2 text-sm font-medium text-foreground shadow-md',
                'ring-2 ring-ring outline-none',
                '-translate-y-[calc(100%+1.25rem)] focus-visible:translate-y-0 motion-reduce:transition-none',
                'transition-transform duration-200 ease-out'
            )}>
            {t('skipToMainContent')}
        </a>
    );
}
